import { useContext } from 'react';
import { StoreContext } from '@roc/feature-app-core';
import { RentalPortfolioStore } from '../stores';

export const useRentalPortfolioStore = () => useContext<{
  rentalPortfolioStore: RentalPortfolioStore
}>(StoreContext);
